<template>
  <section class="edit-map">
    <div class="edit-map__content" v-if="!isEmpty">
      <v-card
        v-for="(item, index) in value"
        :key="index"
        class="edit-map__item"
      >
        <v-row class="edit-map__row">
          <v-col cols="12" sm="12" md="4" class="edit-map__row-item">
          <div class="small-extra-bold">
            Key
          </div>
            <v-text-field
              type="text"
              dense
              outlined
              hide-details="auto"
              @input="updateInput"
              v-model="item.key"
              class="edit-map__input"
            />
          </v-col>
          <v-col cols="12" sm="12" md="7" class="edit-map__row-item">
          <div class="small-extra-bold">
            Value
          </div>
            <v-textarea
              type="text"
              rows="1"
              auto-grow
              dense
              outlined
              hide-details="auto"
              @input="updateInput"
              v-model="item.value"
              class="edit-map__input"
            />
          </v-col>
          <v-col class="d-flex flex-column justify-center" cols="12" sm="12" md="1">
            <div class="small-extra-bold">
              Action
            </div>
            <apio-button
              button-type="delete"
              @click="deleteRow(item.key)"
              class="edit-map__delete"
            >
              <apio-icon lightModeColour="white" name="ui-trash" size="16"></apio-icon>
            </apio-button>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <p class="edit-map__no-results" v-else>
      No values defined yet
    </p>

    <div class="edit-map__actions"> 
      <apio-button
        button-size="medium"
        class="edit-map__add"
        @click="addRow()"
      >
        Add new row
      </apio-button>
    </div>
  </section>
</template>

<script>
export default {
  name: "EditArrayMap",
  data: () => ({
    key: 0,
  }),
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  watch: {
    value() {
      this.key += 1;
    },
    isEmpty() {
      if (this.isEmpty) {
        this.$emit("input", [
          {
            key: 'key-0',
            value: 'value-0'
          },
        ]);
        this.$emit("input", [
          {
            key: 'key-0',
            value: 'value-0'
          },
        ]);
        this.$emit('setAsObject', this.value);
      }
    }
  },
  methods: {
    updateInput() {
      this.$emit("input", this.value);
      this.$emit('setAsObject', this.value);
    },
    deleteRow(key) {
      const currentData = this.value.filter(item => item.key !== key);
      this.$emit("input", currentData);
      this.$emit('setAsObject', currentData);
    },
    addRow() {
      const newItem = {
        value: `value-${this.key}`,
        key: `key-${this.key}`,
      };

      this.$emit("input", [
        ...this.value,
        newItem,
      ]);
      this.$emit("setAsObject", [
        ...this.value,
        newItem,
      ]);
    },
  },
  computed: {
    isEmpty() {
      return this.value.length === 0;
    },
    isSmallDesktop() {
      return this.$vuetify.breakpoint.width > 1024;
    },
  },
};
</script>

<style lang="scss">
.closebtn {
  color: red;
  font-size: 20px;
  cursor: pointer;
  position: relative;
  right: 20px;
  top: 8px;
}

.edit-map {
  &__delete {
    width: 36px;
    height: 36px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    padding: 0;
  }

  &__actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  &__add {
    margin: 1rem 0 2rem 0;
  }

  &__input {
    margin: 0 0 1rem 0;
  }

  &__item {
    padding: 16px;
    background-color: white;
    margin-bottom: 16px;
  }
}
</style>
